<template>
  <div class="page">
    <div class="name">支付聚合平台</div>
    <div class="content">
      <!-- 左侧图案 -->
      <leftImg></leftImg>
      <!-- 注册 -->
      <div class="right">
        <p class="name">注册</p>
        <div class="info">您好，{{ emailAccount }} <br />邮件验证码已发送成功，请登录邮箱查收邮件进行确认操作</div>
        <div class="form">
          <el-input
            class="mailbox"
            v-model="authCode"
            @input="changeStatus"
            placeholder="请输入验证码 "
            maxlength="10"
          ></el-input>
          <div class="agreement">
            <template v-if="vertifySendStatus"> 没有收到？<span @click="sendAgain">重新发送</span> </template>
            <template v-else>
              <span>{{ vertifyCodeTime }}s</span>后可重新发送
            </template>
          </div>
          <el-button :class="[!btnStatus ? 'btn-status' : '', 'btn']" type="primary" @click="btnStatus ? goNext() : ''"
            >下一步</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import leftImg from '@login/components/leftImg';
export default {
  components: {
    leftImg,
  },
  data() {
    return {
      authCode: '', // 验证码
      btnStatus: false, // 按钮可点击状态
      emailAccount: '', // 邮箱
      vertifySendStatus: 1, // 验证码发送状态 0: 不可重新发送 1: 可重新发送
      vertifyCodeTime: 60, // 重新发送计时
      timer: null, // 计时器
      authKey: '', // 获取验证码返回唯一标识
    };
  },
  mounted() {
    this.emailAccount = this.$route.query.emailAccount;
  },
  methods: {
    ...mapActions('login', ['getEmailVerifyCode', 'checkEmailVerifyCode']),
    // 发送验证码
    async sendAgain() {
      try {
        this.vertifySendStatus = 0;
        await this.getEmailVerifyCode({ account: this.emailAccount });
        this.handleVertifyTimeChange();
      } catch (error) {
        this.vertifySendStatus = 1;
        console.error(error);
      }
    },
    // 修改邮箱/协议选中状态
    changeStatus() {
      if (this.authCode != '') {
        this.btnStatus = true;
      } else {
        this.btnStatus = false;
      }
    },
    // 跳转下一步
    async goNext() {
      this.authKey = localStorage.getItem('EMAIL_AK');
      const { authCode, authKey, emailAccount } = this;
      try {
        const res = await this.checkEmailVerifyCode({
          authCode,
          authKey,
          mailAddress: emailAccount,
        });
        this.handleCheckRes(res);
      } catch (error) {
        console.error(error);
      }
    },
    // 根据校验结果执行是否跳转
    handleCheckRes(res) {
      if (res === 'success') {
        this.$message({
          message: '验证成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.$router.replace({
              path: '/register/stepThree',
              query: { emailAccount: this.emailAccount },
            });
          },
        });
        return;
      }
      // 校验失败
      this.$message.error('请输入正确的验证码');
    },
    // 验证码倒计时
    handleVertifyTimeChange() {
      this.timer = setInterval(() => {
        this.vertifyCodeTime -= 1;
        if (this.vertifyCodeTime <= 0) {
          this.vertifySendStatus = 1;
          this.vertifyCodeTime = 60;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 90vh;
  display: flex;
  flex-direction: column;
  padding: 5vh;
}
.name {
  font-size: 22px;
  color: #333;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
}
.content {
  display: flex;
  width: 800px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(67, 89, 183, 0.2);
  border-radius: 8px;
  margin: auto;
}
.right {
  width: 50%;
  height: 400px;
  .name {
    font-size: 22px;
    color: #333;
    padding: 18px 0;
    text-align: center;
  }
  .info {
    width: 330px;
    height: 69px;
    background: #dff7df;
    font-size: 14px;
    line-height: 24px;
    margin: auto;
    padding: 15px;
  }
  .form {
    text-align: center;
  }
  .mailbox {
    width: 360px;
    margin: 15px 0;
  }
  .agreement {
    font-size: 12px;
    color: #333;
    text-align: left;
    margin-left: 20px;
    span {
      color: #4359b7;
      cursor: pointer;
    }
  }
  .btn {
    width: 300px;
    font-size: 14px;
    font-family: Helvetica Neue;
    font-weight: 400;
    margin: 20px 0;
  }
  .btn-status {
    opacity: 0.4;
  }
  .back {
    font-size: 14px;
    color: #666;
    span:nth-child(2) {
      color: #4359b7;
      cursor: pointer;
    }
  }
}
</style>
